import React from "react"
import { Title, Caveat, List, Cta } from "../components/page/services"
import { Seo } from "../components"

export default function ServicesPage() {
  return (
    <React.Fragment>
      <Seo title="" />
      <Title />
      <List />
      <Cta />
      <Caveat />
    </React.Fragment>
  )
}
